import { httpService } from './httpService';
import { LoginResponse, MagicLinkRequest, MagicLinkVerify, User } from '../types';

export const authService = {
  requestMagicLink: async (data: MagicLinkRequest): Promise<void> => {
    await httpService.post('/auth/magic-link?source=hr-dashboard', data);
  },

  verifyMagicLink: async (data: MagicLinkVerify): Promise<LoginResponse> => {
    const response = await httpService.post<LoginResponse>('/auth/login', data);
    return response.data;
  },

  getCurrentUser: async (): Promise<User | null> => {
    if (typeof window === 'undefined') {
      return null;
    }

    const storedUser = window.localStorage.getItem('veraconnect.hr.user');
    return storedUser ? (JSON.parse(storedUser) as User) : null;
  },
};
